<template>
    <div class="dashboard">
        <div class="card-grid">
            <!-- 用户数据 -->
            <el-card class="stat-card" shadow="hover">
                <template #header>
                    <div class="card-header">
                        <el-icon class="card-icon" color="#409eff"><UserFilled /></el-icon>
                        <span class="card-title">用户数据</span>
                    </div>
                </template>
                <div class="stat-list">
                    <div class="stat-item">
                        <span class="stat-label">今日登录量</span>
                        <span class="stat-value">{{ indexData.todayLoginNum }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">今日微信登录量</span>
                        <span class="stat-value">{{ indexData.todayWxLoginNum }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">今日苹果登录量</span>
                        <span class="stat-value">{{ indexData.todayIosLoginNum }}</span>
                    </div>
                </div>
            </el-card>

            <!-- 金额模块 -->
            <el-card class="stat-card" shadow="hover">
                <template #header>
                    <div class="card-header">
                        <el-icon class="card-icon" color="#e6a23c"><Money /></el-icon>
                        <span class="card-title">金额模块</span>
                    </div>
                </template>
                <div class="stat-list">
                    <div class="stat-item">
                        <span class="stat-label">今日提现总额</span>
                        <span class="stat-value highlight">￥{{ Number(indexData.todayTotalMoney || 0).toFixed(2) }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">今日非审核提现总额</span>
                        <span class="stat-value highlight">￥{{ Number(indexData.todayUnCheckMoney || 0).toFixed(2) }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">今日审核提现总额</span>
                        <span class="stat-value highlight">￥{{ Number(indexData.todayCheckMoney || 0).toFixed(2) }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">本月提现总额</span>
                        <span class="stat-value highlight">￥{{ Number(indexData.monthTotalMoney || 0).toFixed(2) }}</span>
                    </div>
                </div>
            </el-card>

            <!-- ECPM模块 -->
            <el-card class="stat-card" shadow="hover">
                <template #header>
                    <div class="card-header">
                        <el-icon class="card-icon" color="#67c23a"><TrendCharts /></el-icon>
                        <span class="card-title">ECPM 模块</span>
                    </div>
                </template>
                <div class="stat-list">
                    <div class="stat-item">
                        <span class="stat-label">今日ECPM总量</span>
                        <span class="stat-value">{{ Number(indexData.todayTotalEcpm || 0).toFixed(2) }}</span>
                    </div>
                </div>
            </el-card>

            <!-- 邀请模块 -->
            <el-card class="stat-card" shadow="hover">
                <template #header>
                    <div class="card-header">
                        <el-icon class="card-icon" color="#f56c6c"><Share /></el-icon>
                        <span class="card-title">邀请模块</span>
                    </div>
                </template>
                <div class="stat-list">
                    <div class="stat-item">
                        <span class="stat-label">被邀请人总数</span>
                        <span class="stat-value">{{ indexData.totalInviteeCount }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">被邀请人ECPM总额</span>
                        <span class="stat-value">{{ Number(indexData.totalInviteeEcpmAmount || 0).toFixed(2) }}</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">被邀请人分成总额</span>
                        <span class="stat-value">￥{{ Number(indexData.totalShareAmount || 0).toFixed(2) }}</span>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
    <router-view/>
</template>

<script>
    import { total } from '../../api/user/user';
    import { UserFilled, Money, TrendCharts, Share } from '@element-plus/icons-vue';
    export default {
        name: "Index",
        components: { UserFilled, Money, TrendCharts, Share },

        data() {
            return {
                indexData: {},
                loading: false,
            }
        },
        mounted() {
            this.selectData();
        },
        methods: {
            selectData() {
                this.loading = true;
                total().then(res => {
                    if (res.data.code === "200") {
                        this.indexData = res.data.data;
                    }
                    this.loading = false;
                }).catch(error => {
                    console.log(error);
                    this.loading = false;
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .dashboard {
        padding: 24px;
        height: calc(100vh - 80px);
        overflow-y: auto;
        background: #f0f2f5;
    }

    .card-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
        max-width: 1400px;
        margin: 0 auto;
    }

    .stat-card {
        border-radius: 12px;
        transition: transform 0.2s ease;

        &:hover {
            transform: translateY(-2px);
        }

        :deep(.el-card__header) {
            padding: 18px 24px 12px;
            border-bottom: 1px solid #ebeef5;
        }

        :deep(.el-card__body) {
            padding: 16px 24px 20px;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .card-icon {
        font-size: 20px;
    }

    .card-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
    }

    .stat-list {
        display: flex;
        flex-direction: column;
        gap: 14px;
    }

    .stat-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 14px;
        background: #fafafa;
        border-radius: 8px;
        transition: background 0.2s;

        &:hover {
            background: #f0f5ff;
        }
    }

    .stat-label {
        font-size: 13px;
        color: #909399;
        white-space: nowrap;
    }

    .stat-value {
        font-size: 16px;
        font-weight: 700;
        color: #303133;
        text-align: right;
        word-break: break-all;

        &.highlight {
            color: #e6a23c;
            font-size: 17px;
        }
    }

    /* ========== iPad 适配 (768px - 1200px) ========== */
    @media (max-width: 1200px) {
        .dashboard {
            padding: 16px;
            height: calc(100vh - 100px);
        }

        .card-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
        }

        .stat-label {
            font-size: 12px;
        }

        .stat-value {
            font-size: 14px;

            &.highlight {
                font-size: 15px;
            }
        }
    }

    /* ========== 手机适配 (< 768px) ========== */
    @media (max-width: 768px) {
        .dashboard {
            padding: 12px;
            height: calc(100vh - 110px);
        }

        .card-grid {
            grid-template-columns: 1fr;
            gap: 14px;
        }

        .stat-card {
            border-radius: 10px;

            :deep(.el-card__header) {
                padding: 14px 16px 10px;
            }

            :deep(.el-card__body) {
                padding: 12px 16px 16px;
            }
        }

        .card-title {
            font-size: 15px;
        }

        .card-icon {
            font-size: 18px;
        }

        .stat-list {
            gap: 10px;
        }

        .stat-item {
            padding: 8px 12px;
            flex-wrap: wrap;
            gap: 4px;
        }

        .stat-label {
            font-size: 12px;
        }

        .stat-value {
            font-size: 14px;

            &.highlight {
                font-size: 15px;
            }
        }
    }
</style>
